/* global angular */
( function () {
	'use strict';

	function GroupButtons ( ) {
		return {
			'templateUrl' : '/templates/components/group/group-buttons/group-buttons.html',
			'restrict'    : 'E',
			'replace'     : true,
			'scope'       : {
				'model'           : '=',
				'index'           : '=',
				'canDelete'       : '=',
				'onDelete'        : '&',
				'viewModeFormula' : '=',
				'viewOnlyMode'    : '=',
				'resourceId'      : '='
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'groupButtons', GroupButtons );
} )( );
